module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/data-bg.26d489ce.png";